import api from '@/services/api/api';
import { TConsumer } from '@/services/api/consumer-api';
import { TReservation, myServicesData } from '@/services/api/services-api';
import { useQuery } from '@tanstack/react-query';

const useGetMyServices = <TResult>(
  select?: (reservations: myServicesData[]) => TResult
) => {
  return useQuery({
    queryKey: ['myServices'],
    queryFn: () => api.services.getMyService(),
    select
  });
};

export const useGetMyReservationById = (
  reservationId: string,
  serviceId: string
) =>
  useGetMyServices<TReservation | undefined>((services) => {
    const service = services.find((service) => serviceId === service.id);
    if (service !== undefined) {
      return service.reservations.find(
        (reservation) => reservation.id === reservationId
      );
    } else return undefined;
  });

export const useGetParticipantById = (
  participantId: string,
  serviceId: string
) =>
  useGetMyServices<TConsumer | undefined>((services) => {
    const service = services.find((service) => serviceId === service.id);
    if (service !== undefined) {
      return service.participants.find(
        (participant) => participant.id === participantId
      );
    } else return undefined;
  });

export default useGetMyServices;
